import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { FlatContractDetail } from 'types/api'
import { BaseParams } from 'types/utils'

export function useCreateContract() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const handleError = useOnError() // Added useOnError

  async function createContract({
    body,
    params = { type: 'flat' }
  }: BaseParams<
    {
      id: string
      payment_time: string
      depositPaid: boolean
    },
    'POST',
    {
      type: 'flat'
    }
  >) {
    const formData = new FormData()
    if (body) {
      Object.entries(body).forEach(([key, value]) => {
        if (value) {
          formData.append(key, value as string | Blob)
        }
      })
    }
    const res = await apiClient.post<FlatContractDetail>(
      `${SNA_PREFIX}contracts`,
      formData,
      {
        params,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return res.data
  }

  return useMutation({
    mutationFn: createContract,
    onSuccess: (_) => {
      toast.success({ message: t('flatCreated') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
    },
    onError: handleError // Updated to use useOnError
  })
}
